export default __webpack_public_path__ + "3d6c34cf94f9c021da16875397536275.png";